import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAlertConfigOptionsRequestDtoSchema = z.object({
  facilityIds: z.array(z.number()),
});

const GetAlertConfigOptionsResponseDtoSchema = z.array(
  z.object({
    label: z.string(),
    value: z.string(),
  })
);

export type GetAlertConfigOptionsRequestDto = z.infer<
  typeof _GetAlertConfigOptionsRequestDtoSchema
>;
export type GetAlertConfigOptionsResponseDto = z.infer<
  typeof GetAlertConfigOptionsResponseDtoSchema
>;

export const getAlertConfigOptions = (
  params: GetAlertConfigOptionsRequestDto,
  config?: AxiosRequestConfig<GetAlertConfigOptionsRequestDto>
) => {
  return api
    .get('alerts/config-options', { params, ...config })
    .then(responseContract(GetAlertConfigOptionsResponseDtoSchema));
};
